import * as React from 'react';
import NavigationCard from '../NavigationCard/NavigationCard';
import S from './DesktopNavigationDropdown.styles';
import { linkAria } from '@helpers/utils';
const DesktopNavigationDropdown = (props) => {
    const items = props.item.children;
    if (!items?.length) {
        return null;
    }
    const hasThirdLevel = items.some((item) => !!item.children?.length);
    const hasCards = !!props.item.cards?.length;
    if (!hasThirdLevel) {
        return (React.createElement(S.Container, { "data-cards": hasCards, "data-third": hasThirdLevel },
            React.createElement(S.ColumnList, null,
                React.createElement(S.Column, { "data-layout": "default" },
                    React.createElement(S.List, null, items.map((item) => (React.createElement(S.Item, { key: item.id },
                        React.createElement(S.Link, { "aria-label": linkAria(item.title ?? '', item.target, props.translations && props.translations['lcci.link.newtab']), href: item.url },
                            React.createElement(S.LinkTitle, null, item.title),
                            item.summary && React.createElement(S.LinkSummary, null, item.summary))))))),
                props.item.cards && (React.createElement(S.Column, { "data-layout": "wide" },
                    React.createElement(S.CardList, null, props.item.cards.map((item) => (React.createElement(S.CardItem, { key: item.id },
                        React.createElement(NavigationCard, { ...item }))))))))));
    }
    return (React.createElement(S.Container, { "data-cards": hasCards, "data-third": hasThirdLevel },
        React.createElement(S.ColumnList, null,
            items.map((item) => {
                const childItem = item.children ?? [];
                const layout = items.length > 2
                    ? 'default'
                    : hasThirdLevel && childItem.length > 6
                        ? 'wide'
                        : 'default';
                return (React.createElement(S.Column, { key: item.id, "data-layout": layout },
                    React.createElement(S.ColumnTitle, null, item.title),
                    React.createElement(S.List, null, item.children?.map((item) => (React.createElement(S.Item, { key: item.id },
                        React.createElement(S.Link, { "aria-label": linkAria(item.title ?? '', item.target, props.translations && props.translations['lcci.link.newtab']), href: item.url },
                            React.createElement(S.LinkTitle, null, item.title),
                            item.summary && React.createElement(S.LinkSummary, null, item.summary))))))));
            }),
            props.item.cards && (React.createElement(S.Column, { "data-layout": "wide" },
                React.createElement(S.CardList, null, props.item.cards.map((item) => (React.createElement(S.CardItem, { key: item.id },
                    React.createElement(NavigationCard, { ...item }))))))))));
};
export default DesktopNavigationDropdown;
